import { render, staticRenderFns } from "./zm-form.vue?vue&type=template&id=b96d96ec&scoped=true&"
import script from "./zm-form.vue?vue&type=script&lang=js&"
export * from "./zm-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b96d96ec",
  null
  
)

export default component.exports